<template src='./application.html'></template>

<script>

import SideMenu from "@/components/sidemenu/sidemenu.vue"

export default {
  name: "Application",
  components: {
    SideMenu,
  },
  data() {
    return {

    }
  },
  mounted() {
    
  },
  methods: {    
   handleMenuSelection(method) {
    
      if(method) {
        
        this.$router.push({ path: method })
      } 
      else {
      
        console.debug("Method is undefined for the selected menu item")
      }
    },
  },
  selectItem(item) {
    
    if(method) {
      
      this.$emit('menu-item-selected', method)
    } 
    else {
    
      console.debug('Method is undefined for the selected menu item')
    }
  },
}

</script>